<template>
    <div id="BannerSection">
      <img class="title-img" :src="require('@/assets/images/marketing/title.png')"/>
      <div class="wrap">
        <div class="image">
          <img class="main-img" :src="require('@/assets/images/marketing/body.png')"/>
        </div>
        <div class="title">
          <span>내일 바로 지급 되는</span><br/><span class="blue-text">마케팅론 출시!</span>
        </div>
      </div>
  </div>
</template>

<script>

export default {
  name: 'BannerSection',
  data() {
    return {
      phone: ''
    }
  },
  methods: {
    submit() {
      alert('신청되었습니다.')
    },
    inputPhoneNum() {
      let phone = this.phone
      if (phone != null && phone.length > 0) {
        this.phone = phone.replace(/[^\d]/g, '')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  #BannerSection {
    // height: 85vh;
    // background: url( '../../../assets/images/marketing/body.png');
    // background-repeat: no-repeat;
    // background-position-y: 150px;
    // background-size: 100% 100%;
    padding-left: 2.82vw;
    padding-right: 2.82vw;
   .wrap {
      width: 100%;
      margin: 10px auto;
      position: relative;
    }
    .wrap img{
      width: 100%;
      vertical-align: middle;
    }
    .title {
        text-align: center;
        position: absolute;
        top: 60px;
        left: 50%;
        width: 100%;
        transform: translate(-50%, -50%);
        font-size: 25pt;
        text-align: center;
        .blue-text{
          color: #00ADE5;
          font-weight: 800;
        }
    }

    .main-img {
      padding-top: 90px;
    }

    .title-img {
      padding-top: 20px;
      width: 90%;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative; left: 50%; transform: translateX(-50%);
    }
  }
</style>
